var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "Overlay",
      on: {
        mouseleave: function ($event) {
          _vm.visible = false
        },
      },
    },
    [
      _c("img", {
        staticClass: "Point-Img",
        attrs: { src: require("../../../assets/png/qiziPoint.png"), alt: "" },
        on: { mouseenter: _vm.pointMap },
      }),
      _c(
        "el-popover",
        {
          attrs: {
            placement: "left",
            title: "",
            width: "300",
            offset: 10,
            trigger: "manual",
          },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "Map-Show-Content",
              on: { click: _vm.toStockDetail },
            },
            [
              _c("div", { staticClass: "MSC-Left" }, [
                _vm.stockMap.price > 0
                  ? _c("span", [
                      _vm._v(
                        _vm._s(_vm.stockMap.price) +
                          " " +
                          _vm._s(_vm.stockMap.currency)
                      ),
                    ])
                  : _c("span", [_vm._v("点击询价")]),
                _c("img", {
                  attrs: {
                    id: "pic-class",
                    src: _vm.pic ? _vm.pic : _vm.noImage,
                    alt: "",
                  },
                }),
              ]),
              _c("div", { staticClass: "MSC-Right" }, [
                _c("div", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.stockMap.nameCn)),
                ]),
                _c("div", { staticClass: "address" }, [
                  _vm.stockMap.addressCn
                    ? _c("i", {
                        staticClass: "el-icon-location-outline van-icon",
                      })
                    : _vm._e(),
                  _c("span", { staticClass: "ellipsis" }, [
                    _vm._v(_vm._s(_vm.stockMap.addressCn)),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _c("stockDetail", { ref: "stockDetail" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }